import { Routes } from '@angular/router';
import { AUTH_ROUTES } from '@auth/auth.routes';
import { ROUTE_KEYS } from '@shared/permissions/route-keys.const';

export const routes: Routes = [
  {
    path: AUTH_ROUTES.root,
    loadChildren: () => import('./app-auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'app',
    loadChildren: () => import('./app-admin-portal/admin-portal.routes').then((m) => m.adminPortalRoutes),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: AUTH_ROUTES.root + '/' + AUTH_ROUTES.login,
  },
];
